import React from 'react';
import '../Menu/Menu.css';
import img from "../../img/logo1.png";

function Menu() {
  return (
    <>
      <section className="about-section1 d-flex align-items-center">
        <div className="container text-center text-white">
          <h1 className="fw-bold">Menu</h1>
        </div>
      </section>

      <div className="container my-5">
        <h2 className="menu-title">Menu</h2>
        <div className="row text-start">


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Welcome Drink</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Fruit Punch</li>
              <li><img src={img} alt="" /> Coconut water with mint</li>
              <li><img src={img} alt="" /> Lichi Blossom</li>
              <li><img src={img} alt="" /> Orange Blossom</li>
              <li><img src={img} alt="" /> Khus Blossom</li>
              <li><img src={img} alt="" /> Fresh Fruit Juice</li>
              <li><img src={img} alt="" /> Mocktel Juice</li>
              <li><img src={img} alt="" /> Cold Drink</li>
              <li><img src={img} alt="" /> Lassi</li>
              <li><img src={img} alt="" /> Milk Shake</li>
              <li><img src={img} alt="" /> Thandhai</li>
              <li><img src={img} alt="" /> Tea / Coffee</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Snack / Starter</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Mint Paneer Tikka</li>
              <li><img src={img} alt="" /> Hara Bhara Kabab</li>
              <li><img src={img} alt="" /> Cheese Ball</li>
              <li><img src={img} alt="" /> Cheese Corn Ball</li>
              <li><img src={img} alt="" /> Spaghatti Balls</li>
              <li><img src={img} alt="" /> Paneer 65</li>
              <li><img src={img} alt="" /> Paneer Finger</li>
              <li><img src={img} alt="" /> Aloo mint Dry</li>
              <li><img src={img} alt="" /> Mutter Potli</li>
              <li><img src={img} alt="" /> Veg Sik Kabab</li>
              <li><img src={img} alt="" /> Rosted Gobhi</li>
              <li><img src={img} alt="" /> Sev Cutlets</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Chaat Item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Flavoured Pani puri</li>
              <li><img src={img} alt="" /> Bhel Puri</li>
              <li><img src={img} alt="" /> Sav Puri</li>
              <li><img src={img} alt="" /> Samosa Chat</li>
              <li><img src={img} alt="" /> Basket Chat</li>
              <li><img src={img} alt="" /> Batata Vada Chat</li>
              <li><img src={img} alt="" /> Shahi Tokri Chat</li>
              <li><img src={img} alt="" /> Gujia Dahi Chat</li>
              <li><img src={img} alt="" /> Vada Pav</li>
              <li><img src={img} alt="" /> Pav Bhaji</li>
              <li><img src={img} alt="" /> Masala Puri</li>
              <li><img src={img} alt="" /> Moong Dal Chilla</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Soup Item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Tomato Soup</li>
              <li><img src={img} alt="" /> Sweet Corn Soup</li>
              <li><img src={img} alt="" /> Cheese Soup</li>
              <li><img src={img} alt="" /> Onion Soup</li>
              <li><img src={img} alt="" /> Veg Soup</li>
              <li><img src={img} alt="" /> Mushroom Soup</li>
              <li><img src={img} alt="" /> Brokali Soup</li>
              <li><img src={img} alt="" /> Apple Soup</li>
              <li><img src={img} alt="" /> Pumpkin Soup</li>
              <li><img src={img} alt="" /> Noodle Soup</li>
              <li><img src={img} alt="" /> Leek Soup</li>
              <li><img src={img} alt="" /> Minestrone Soup</li>
            </ul>
          </div>

        </div>
<br/>
        <div className="row text-start">


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Veg gravy item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Paneer Butter Masala</li>
              <li><img src={img} alt="" /> Mutter Paneer</li>
              <li><img src={img} alt="" /> Paneer Makhana</li>
              <li><img src={img} alt="" /> Sahi Paneer</li>
              <li><img src={img} alt="" /> Kaju mutter Makhana</li>
              <li><img src={img} alt="" /> Palak Corn</li>
              <li><img src={img} alt="" /> Palak Aloo</li>
              <li><img src={img} alt="" /> Palak Baby corn</li>
              <li><img src={img} alt="" /> Haryali Chhola</li>
              <li><img src={img} alt="" /> Dumm Aloo</li>
              <li><img src={img} alt="" /> Malai Kofta</li>
              <li><img src={img} alt="" /> Veg Kofta</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Tava Item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Fulka</li>
              <li><img src={img} alt="" /> Tava Roti</li>
              <li><img src={img} alt="" /> Rumali Roti</li>
              <li><img src={img} alt="" /> Makai ki Roti</li>
              <li><img src={img} alt="" /> Bajre Ki Roti</li>
              <li><img src={img} alt="" /> Kulcha</li>
              <li><img src={img} alt="" /> Pudina Kulcha</li>
              <li><img src={img} alt="" /> Stuffed Kulcha</li>
              <li><img src={img} alt="" /> Plain Parotha</li>
              <li><img src={img} alt="" /> Methi Parotha</li>
              <li><img src={img} alt="" /> Stuff Parotha</li>
              <li><img src={img} alt="" /> Lachha Parotha</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Rice Item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Plain Rice</li>
              <li><img src={img} alt="" /> Ghee Jeera Rice</li>
              <li><img src={img} alt="" /> Sweet Rice (Dry fruits)</li>
              <li><img src={img} alt="" /> Veg Biryani</li>
              <li><img src={img} alt="" /> Veg Pullav</li>
              <li><img src={img} alt="" /> Gream Peas Pullav</li>
              <li><img src={img} alt="" /> Corn Pullav</li>
              <li><img src={img} alt="" /> Tiranga Pullav</li>
              <li><img src={img} alt="" /> Kashmiri Pullav</li>
              <li><img src={img} alt="" /> Kabuli Pullav</li>
              <li><img src={img} alt="" /> Tava Pullav</li>
              <li><img src={img} alt="" /> Pudina Pullav</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Dal / Curry</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Moong Dal</li>
              <li><img src={img} alt="" /> Green Dal</li>
              <li><img src={img} alt="" /> Yellow Dal</li>
              <li><img src={img} alt="" /> Makhani Dal</li>
              <li><img src={img} alt="" /> Channa Dal Tadka</li>
              <li><img src={img} alt="" /> Panch Meli Dal</li>
              <li><img src={img} alt="" /> Plain Kadhi</li>
              <li><img src={img} alt="" /> Pakodi Kadhi</li>
              <li><img src={img} alt="" /> Gujrati Kadhi</li>
              <li><img src={img} alt="" /> Sindhi Kadhi</li>
              <li><img src={img} alt="" /> Pineapple Kadhi</li>
              <li><img src={img} alt="" /> Punjabi Kadhi</li>
            </ul>
          </div>

        </div>
<br/>
        <div className="row text-start">


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Salad Item</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Green Salad</li>
              <li><img src={img} alt="" /> Fruit Salad</li>
              <li><img src={img} alt="" /> Cabbage Pineapple Salad</li>
              <li><img src={img} alt="" /> Chana Coconut Salad</li>
              <li><img src={img} alt="" /> Sprouted Salad</li>
              <li><img src={img} alt="" /> Rajma Salad</li>
              <li><img src={img} alt="" /> Sunshine Salad</li>
              <li><img src={img} alt="" /> Bean Salad</li>
              <li><img src={img} alt="" /> Vegetable Pasta Salad</li>
              <li><img src={img} alt="" /> Macaroni Salad</li>
              <li><img src={img} alt="" /> Cheesy Fruit Salad</li>
              <li><img src={img} alt="" /> Cream Salad</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Dessert</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Chocolate Icecream</li>
              <li><img src={img} alt="" /> Vanila Icecream</li>
              <li><img src={img} alt="" /> Butter Scotch</li>
              <li><img src={img} alt="" /> Kesar Pista</li>
              <li><img src={img} alt="" /> Strawberry Icecream</li>
              <li><img src={img} alt="" /> Vanila Chocolate Cone</li>
              <li><img src={img} alt="" /> Malai Kulfi</li>
              <li><img src={img} alt="" /> Chickoo Kulfi</li>
              <li><img src={img} alt="" /> Kesar Pista Kulfi</li>
              <li><img src={img} alt="" /> Badam Pista Kulfi</li>
              <li><img src={img} alt="" /> Mango Kulfi</li>
              <li><img src={img} alt="" /> Ice Cream Faluda Milk</li>
            </ul>
          </div>


          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Sweets</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Gulab Jamun</li>
              <li><img src={img} alt="" /> Kaju Barfi</li>
              <li><img src={img} alt="" /> Badam Barfi</li>
              <li><img src={img} alt="" /> Kesar Sandesh</li>
              <li><img src={img} alt="" /> Lichi sandesh</li>
              <li><img src={img} alt="" /> Petha Roll</li>
              <li><img src={img} alt="" /> Moong Dal Sira</li>
              <li><img src={img} alt="" /> Maal pua</li>
              <li><img src={img} alt="" /> Besan ki Barfi</li>
              <li><img src={img} alt="" /> Halwa</li>
              <li><img src={img} alt="" /> Balushahi</li>
              <li><img src={img} alt="" /> Badam Jalebi</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 menu-section">
            <h4>Milk Sweets</h4>
            <ul className="menu-list">
              <li><img src={img} alt="" /> Rasgulla</li>
              <li><img src={img} alt="" /> Rajbhog</li>
              <li><img src={img} alt="" /> Rasmalai</li>
              <li><img src={img} alt="" /> Kesar Bhog</li>
              <li><img src={img} alt="" /> Gajra Bahar</li>
              <li><img src={img} alt="" /> Chhena Toast</li>
              <li><img src={img} alt="" /> Malai Chop</li>
              <li><img src={img} alt="" /> Chhena Paise</li>
              <li><img src={img} alt="" /> Kesar Peda</li>
              <li><img src={img} alt="" /> Dudhi Halwa</li>
              <li><img src={img} alt="" /> Shree Khand</li>
              <li><img src={img} alt="" /> Cream Roll</li>
            </ul>
          </div>

        </div>
      </div>

    </>
  )
}

export default Menu
